export default class CurrencyGenerator {
    static Currencies = {
        'CAD': {title: "Canadian Dollar", symbol: "$"},
        'USD': {title: "US Dollar", symbol: "$"},
        'AUD': {title: "Australian Dollar", symbol: "$"},
        'CHF': {title: "Swiss Franc", symbol: "CHF"},
        'EUR': {title: "Euro", symbol: "€"},
        'GBP': {title: "Pound Sterling", symbol: "£"},
        'HKD': {title: "Hong Kong Dollar", symbol: "$"},
        'CNY': {title: "Chinese Yuan Renminbi", symbol: "¥"},
        'INR': {title: "Indian Rupee", symbol: "₹"},
        'MYR': {title: "Malaysian Ringgit", symbol: "RM"},
        'PHP': {title: "Philippines Peso", symbol: "₱"},
        'PLN': {title: "Poland, Zloty", symbol: "zł"},
        'SEK': {title: "Swedish Krona", symbol: "kr"},
        'SGD': {title: "Singapore Dollar", symbol: "$"},
    };

    static getCurrencyString(currency, value) {
        let formatter = new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: currency,
        });
        if (value) {
            return formatter.format(parseFloat(value));
        } else {
            return formatter.format(0).slice(0, -4);
        }

    }
}